import { Navigate, useLocation, useParams } from 'react-router-dom'

const LEGACY_TYPE_PARAM = 'type'

const legacySections: Record<string, string> = {
  groups: 'groups',
  locations: 'locations',
  'ors-runtime': 'settings',
  reviewers: 'status/reviewers',
  settings: 'settings',
}

const LegacyLocationsRedirect = () => {
  const { slug } = useParams<{ slug: string }>()
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const section =
    legacySections[searchParams.get(LEGACY_TYPE_PARAM) ?? ''] ?? 'locations'

  searchParams.delete(LEGACY_TYPE_PARAM)

  const nextSearch = searchParams.toString()

  return (
    <Navigate
      replace
      to={{
        pathname: `/games/${slug}/map/${section}`,
        search: nextSearch ? `?${nextSearch}` : '',
      }}
    />
  )
}

export default LegacyLocationsRedirect
